import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles, withStyles, Button, CircularProgress } from "@material-ui/core";
import { DELETE_REPORT } from "../../../Services/Graph/MarketReportPage/MarketReportPageMutations";
import { useMutation } from "@apollo/client";
import { authApolloClient } from "../../../Services/Graph/apolloConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    areYouSureModalContainer: {
      position: "fixed",
      height: "0%",
      width: "100%",
      top: "0px",
      left: "0px",
      background: "rgba(0, 0, 0, 0.7)",
      zIndex: "10",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
    },
    modalOpen: {
      height: "100%",
    },
    areYouSureModalContentContainer: {
      borderRadius: "20px",
      background: "#FFFFFF",
      padding: "30px",
      maxWidth: "767px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    areYouSureText: {
      fontFamily: theme.typography.secondary,
      fontWeight: "700",
      fontSize: "24px",
      color: "#000",
      textTransform: "uppercase",
      letterSpacing: "0.195em",
    },
    areYouSureSubText: {
      fontFamily: theme.typography.secondary,
      fontWeight: "600",
      fontSize: "18px",
      color: "#000",
      margin: "20px 0px",
      textAlign: "center",
    },
    subText: {
      fontFamily: theme.typography.secondary,
      fontWeight: "600",
      fontSize: "18px",
      color: "#000",
      margin: "10px 0px 0px",
      textAlign: "center",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "40px",
    },
    loader: {
      width: "22px !important",
      height: "22px !important",
      color: " #FFFFFF",
      marginLeft: "10px",
    },
  })
);

const CloseButton = withStyles((theme) => ({
  root: {
    color: "#fff",
    background: theme.palette.areaPulseErrorLight,
    fontSize: "16px",
    fontFamily: theme.typography.secondary,
    fontWeight: "700",
    padding: "5px 30px",
    borderRadius: "7px",
    transition: "0.2s",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      background: theme.palette.areaPulseErrorLight,
      transition: "0.2s",
      opacity: "0.8",
    },
  },
}))(Button);

const CancelButton = withStyles((theme) => ({
  root: {
    color: "#C6C6C6",
    fontSize: "16px",
    fontFamily: theme.typography.secondary,
    fontWeight: "700",
    padding: "5px 10px",
    borderRadius: "7px",
    transition: "0.2s",
    textTransform: "lowercase",
    marginRight: "5px",
  },
}))(Button);

const DeletePopUp = ({ reportHasSubscription, setDoTransition, setReportWasDeleted, currentKey, setCurrentKey, setDeleteKey, reportUp, setReportUp, setPullDelete, deleteReportID }) => {
  const classes = useStyles();
  const [deleteReport, { data: deleteData, loading: deleteLoading }] = useMutation(DELETE_REPORT, {
    variables: {
      id: deleteReportID,
    },
    client: authApolloClient,
  });
  const handleClose = () => {
    setDeleteKey(currentKey);
    setCurrentKey(Number);
    setReportWasDeleted(true);
    setDoTransition(true);
    deleteReport();
  };
  const handleCancel = () => {
    setReportUp(false);
  };

  useEffect(() => {
    if (deleteData !== undefined && deleteLoading === false) {
      setReportUp(false);
      setPullDelete(true);
    }
  }, [deleteLoading, deleteData, setReportUp, setPullDelete]);

  return (
    <div className={`${classes.areYouSureModalContainer} ${reportUp && classes.modalOpen}`} onClick={() => handleCancel()}>
      <div className={classes.areYouSureModalContentContainer} onClick={(e) => e.stopPropagation()}>
        <h1 className={classes.areYouSureText}>Are You Sure?</h1>
        {reportHasSubscription !== 0 ? <div className={classes.subText}>This report has current suscriptions and those subscriptions will be lost.</div> : null}
        <h1 className={classes.areYouSureSubText}>Deleting this report will delete all data, and cannot be returned.</h1>
        <div className={classes.buttonContainer}>
          <CancelButton onClick={() => handleCancel()}>cancel</CancelButton>
          <CloseButton disabled={deleteLoading} onClick={() => handleClose()}>
            Delete
            {deleteLoading ? <CircularProgress className={classes.loader} /> : null}
          </CloseButton>
        </div>
      </div>
    </div>
  );
};

DeletePopUp.propTypes = {
  setDoTransition: PropTypes.func,
  setReportWasDeleted: PropTypes.func,
  setCurrentKey: PropTypes.func,
  currentKey: PropTypes.number,
  setDeleteKey: PropTypes.func,
  deleteKey: PropTypes.number,
  reportUp: PropTypes.bool,
  reportHasSubscription: PropTypes.number,
  setReportUp: PropTypes.func,
  setPullDelete: PropTypes.func,
  deleteReportID: PropTypes.number,
};

export default DeletePopUp;
